import List from './views/List.vue'
import CreateEdit from './views/CreateEdit.vue'
import Get from './views/Get.vue'

export const PositionRoutes = [
  {
    path: '/positions',
    name: 'ListPositions',
    component: List,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'position:list'
    }
  },
  {
    path: '/position/',
    name: 'CreatePosition',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'position:create'
    }
  },
  {
    path: '/position/:id',
    name: 'UpdatePosition',
    component: CreateEdit,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'position:update'
    }
  },
  {
    path: '/position/view/:id',
    name: 'GetPosition',
    component: Get,
    meta: {
      auth: true,
      layout: 'home',
      permission: 'position:get'
    }
  }
]
